import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/vercel/path0/layouts/auth.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/vercel/path0/layouts/dashboard.vue").then(m => m.default || m))
}